import React from "react";

// Helper: Check if link is embeddable (YouTube, Spotify, Google Drive, or iframe HTML)
export const isEmbeddableLink = (url: string) => {
  if (!url) return false;
  // YouTube
  if (/youtube\.com\/watch\?v=|youtu\.be\//.test(url)) return true;
  // Spotify
  if (/open\.spotify\.com\//.test(url)) return true;
  // Google Drive
  if (/drive\.google\.com\//.test(url)) return true;
  // Direct iframe HTML
  if (/^<iframe[\s\S]*<\/iframe>$/.test(url.trim())) return true;
  return false;
};

const EmbeddedLinkPreview = ({ link }: { link: string }) => {

  // Direct iframe HTML
  if (/^<iframe[\s\S]*<\/iframe>$/.test(link.trim())) {
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: link }} />;
  }
  
  // YouTube
  if (/youtube\.com\/watch\?v=|youtu\.be\//.test(link)) {
    let videoId = "";
    if (link.includes("youtu.be/")) {
      videoId = link.split("youtu.be/")[1].split(/[?&]/)[0];
    } else {
      const match = link.match(/[?&]v=([^&]+)/);
      videoId = match ? match[1] : "";
    }
    return (
      <iframe
        width="350"
        height="200"
        src={`https://www.youtube.com/embed/${videoId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube Preview"
        style={{ borderRadius: 8, width: "100%", maxWidth: 500 }}
      />
    );
  }
  // Spotify
  if (/open\.spotify\.com\//.test(link)) {
    const embedUrl = link.replace("open.spotify.com/", "open.spotify.com/embed/");
    return (
      <iframe
        src={embedUrl}
        width="350"
        height="80"
        frameBorder="0"
        allow="encrypted-media"
        title="Spotify Preview"
        style={{ borderRadius: 8, width: "100%", maxWidth: 500 }}
      />
    );
  }
  // Google Drive
  if (/drive\.google\.com\//.test(link)) {
    // Try to extract file id
    let fileId = "";
    const match = link.match(/\/d\/([\w-]+)/);
    if (match) fileId = match[1];
    if (fileId)
      return (
        <iframe
          src={`https://drive.google.com/file/d/${fileId}/preview`}
          width="350"
          height="200"
          allow="autoplay"
          title="Google Drive Preview"
          style={{ borderRadius: 8, width: "100%", maxWidth: 500 }}
        />
      );
    // fallback: try to embed the link directly
    return (
      <iframe
        src={link}
        width="350"
        height="200"
        allow="autoplay"
        title="Google Drive Preview"
        style={{ borderRadius: 8, width: "100%", maxWidth: 500 }}
      />
    );
  }
  return null;
};

export default EmbeddedLinkPreview; 